import { excludeNullOrUndefined } from 'checkout/utils'
import createSelector from 'lib/createSelector'
import { getAccommodationBreakdownView } from './accommodation'
import { getExperienceBreakdownView, getTransfersBreakdownView } from './experience'
import { getFlightBreakdownView } from './flights'
import { getInsuranceBreakdownView } from './insurance'
import { getCarHireBreakdownView } from './carHire'
import { getBundleAndSaveBreakdownView } from './bundleAndSave'
import { getAllItemViews } from 'selectors/checkoutSelectors'

export const breakdownView = createSelector(
  getAccommodationBreakdownView,
  getExperienceBreakdownView,
  getTransfersBreakdownView,
  getFlightBreakdownView,
  getInsuranceBreakdownView,
  getCarHireBreakdownView,
  getBundleAndSaveBreakdownView,
  (...views): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    const allViews = views.flatMap(view => view.data).filter(excludeNullOrUndefined)

    return {
      hasRequiredData: views.every(o => o.hasRequiredData),
      data: allViews,
    }
  },
)

export const hasPurchasableItems = createSelector(
  getAllItemViews,
  (allItemViews) => {
    if (!allItemViews.hasRequiredData) {
      return {
        hasRequiredData: false,
        data: false,
      }
    }
    return (
      allItemViews.data.accommodationItemsView.data.length > 0 ||
      allItemViews.data.flightItemsView.data.length > 0 ||
      allItemViews.data.insuranceItemsView.data.length > 0 ||
      allItemViews.data.transferItemsView.data.length > 0 ||
      allItemViews.data.experienceItemsView.data.some(item => (
        item.ticketViews.some(ticket => !ticket.unavailable)
      ))
    )
  },
)
